import { User } from '@supabase/supabase-js'
import { redirect } from 'react-router-dom'
import { getSession } from '../helpers/supabase'

// Checkout runs this in parallel with getPricesLoader. getSession reads local
// auth state and does not hold the GoTrue lock across a /auth/v1/user request,
// which is what crashed this loader with "lock was stolen".
export default async function getUserLoader({
  request,
}: {
  request: Request
}): Promise<User | Response> {
  const { data } = await getSession()
  const user = data?.session?.user

  if (!user) {
    const url = new URL(request.url)
    const urlSearchParams = new URLSearchParams(url.search)

    if (url.pathname) {
      urlSearchParams.append('path', url.pathname)
    }

    return redirect('/account/sign-in?' + urlSearchParams.toString())
  }

  return user
}
